export const modifyFontFamily = (modifierFn) => (fontFamily) => fontFamily
    .split(',')
    .map((ff) => cleanFontFamilyName(ff))
    .map(modifierFn)
    .reduce((acc, curr) => [...acc, ...curr], [])
    .filter(Boolean)
    .join(',');
function cleanFontFamilyName(fontFamilyName) {
    return fontFamilyName.trim().replace(/"/g, '').replace(/'/g, '');
}
//# sourceMappingURL=modify-font-family.js.map